var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuccessIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.475,
    height: 27.476
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.738 0A13.738 13.738 0 110 13.738 13.738 13.738 0 0113.738 0z",
    opacity: 0.14,
    fill: "#1868b9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.991 20.295a1.676 1.676 0 01-1.009-.335l-.018-.014-3.8-2.909a1.688 1.688 0 112.053-2.68l2.461 1.887 5.815-7.584a1.688 1.688 0 012.366-.316l-.036.049.037-.048a1.69 1.69 0 01.312 2.367l-6.84 8.921a1.688 1.688 0 01-1.341.662z",
    fill: "#1868b9"
  })));
}

export default __webpack_public_path__ + "996d3625d5dcb6e7de19ec1cc358763f.svg";
export { SvgSuccessIcon as ReactComponent };